import { Link } from 'wouter';
import { Button } from '@/components/ui/button';

export default function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background p-6 text-center">
      <p className="text-5xl font-semibold text-muted-foreground">404</p>
      <h1 className="text-xl font-medium">页面不存在</h1>
      <p className="max-w-md text-sm text-muted-foreground">
        您访问的页面可能已被移除、改名，或暂不可用。
      </p>
      <Button onClick={() => window.history.back()}>返回上一页</Button>
      <Link href="/" className="text-sm text-primary underline-offset-4 hover:underline">
        回到仪表板
      </Link>
    </div>
  );
}
